import React from 'react';

const streetEasyUrl = 'https://streeteasy.com/agent-resources/advertise/reach-millions-active-buyers-renters-nyc/';
const learnMoreUrl = 'http://www.zillow.com/rental-property-advertising?utm_medium=referral&utm_content=learnmorelink'
    + '&utm_source=zrm&utm_campaign=zrm_add_property';


const ErrorMessageConstants = {
    LOCATION_RESTRICTION: {
        NYC: [
            'This listing may not get published. Please visit ',
            <a href={streetEasyUrl} target="_blank" rel="noopener noreferrer">StreetEasy</a>,
            ' to list a rental in this area of New York.',
        ],
        MF_REQUIRED: [
            'This address is a 50+ unit apartment community, which requires a Zillow advertising contract. ',
            'For more information, see ',
            <a href={learnMoreUrl} target="_blank" rel="noopener noreferrer">here</a>,
            '.',
        ],
        DUPLICATE: {
            MESSAGE: 'This property is already posted.',
            LINK_TEXT: 'View Listing',
        },
    },
    DEFAULT_PHOTO_ERROR: 'There was an error with your photo upload. Please check the field for errors and try again.',
    DELETE_LAST_PHOTO_ACTIVE_LISTING_ERROR: 'Active listings must have at least one photo',
    DELETE_PHOTO_ERROR: 'There was an error deleting the photo. Please, try again.',
    DEFAULT_ERROR: 'Sorry, something went wrong. Please try again later.',
    SINGLE_FAMILY_NO_ACTIVE_CONTRACT: 'There is no active contract. Please contact rentalshelp@zillowgroup.com.',
    SINGLE_FAMILY_CANNOT_RETRIEVE_CONTRACTS: 'Cannot retrieve active contacts, please try again later.',
};

export default ErrorMessageConstants;
